import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CancelIcon from "@material-ui/icons/Cancel";
import SaveIcon from "@material-ui/icons/Save";
import { useFormik } from "formik";
import React, { useState } from "react";
import styled from "styled-components";
import * as yup from "yup";
import LoginBranding from "../../components/login/LoginBranding";
import {
  LoginContainer,
  RightPanel,
  LoginContent,
  ContainerLogo,
  SeidorLogo
} from "../../components/login/styles";

const validationSchema = yup.object({
  email: yup
    .string("Informe o login")
    .email("Email formato incorreto")
    .required("Login é obrigatório"),
  oldPassword: yup.string().required("Senha anterior é obrigatória"),
  nickname: yup.string().required("Apelido é obrigatório"),
  newPassword: yup.string().required("Nova senha é obrigatória"),
  passwordConfirmation: yup
    .string()
    .required("Confirmação de senha é obrigatória")
    .test("passwords-match", "As senhas devem ser iguais", function (value) {
      return this.parent.newPassword === value;
    }),
});

function NewPassword({ userCognito, completeNewPassword, cancel }) {
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { email, password } = userCognito;

  const formik = useFormik({
    initialValues: {
      email: email,
      oldPassword: password,
      newPassword: "",
      passwordConfirmation: "",
      nickname: "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsLoading(true);
      completeNewPassword(values, setIsLoading);
    },
    onFailure: () => {
      setIsLoading(false);
    }
  });

  return (
    <LoginContainer>
      <LoginBranding />
      <RightPanel>
        <LoginContent>
          <Title>Criar Nova Senha</Title>
          <SubText>Por favor, defina um apelido e uma nova senha para sua conta</SubText>
          <form>
            <FieldContainer>
              <TextField
                fullWidth
                disabled
                InputLabelProps={{ shrink: true }}
                id="email"
                name="email"
                label="E-mail"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                autoComplete="off"
                variant="outlined"
              />
            </FieldContainer>
            <FieldContainer>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="nickname"
                name="nickname"
                label="Apelido"
                value={formik.values.nickname}
                onChange={formik.handleChange}
                error={formik.touched.nickname && Boolean(formik.errors.nickname)}
                helperText={formik.touched.nickname && formik.errors.nickname}
                autoComplete="off"
                variant="outlined"
              />
            </FieldContainer>
            <FieldContainer>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="newPassword"
                name="newPassword"
                label="Nova Senha"
                type={showNewPassword ? "text" : "password"}
                value={formik.values.newPassword}
                onChange={formik.handleChange}
                error={
                  formik.touched.newPassword && Boolean(formik.errors.newPassword)
                }
                helperText={
                  formik.touched.newPassword && formik.errors.newPassword
                }
                autoComplete="off"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        edge="end"
                      >
                        {showNewPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FieldContainer>
            <FieldContainer>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="passwordConfirmation"
                name="passwordConfirmation"
                label="Confirmar Senha"
                type={showConfirmPassword ? "text" : "password"}
                value={formik.values.passwordConfirmation}
                onChange={formik.handleChange}
                error={
                  formik.touched.passwordConfirmation &&
                  Boolean(formik.errors.passwordConfirmation)
                }
                helperText={
                  formik.touched.passwordConfirmation &&
                  formik.errors.passwordConfirmation
                }
                autoComplete="off"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        edge="end"
                      >
                        {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FieldContainer>
            <ContainerButtons>
              <ButtonOptions>
                <ButtonCancel onClick={cancel}>
                  <ContainerButtonsIcon>
                    <CancelIcon />
                  </ContainerButtonsIcon>
                  <CustomButtonLabel>Cancelar</CustomButtonLabel>
                </ButtonCancel>
                <ButtonSave onClick={formik.handleSubmit} disable={isLoading}>
                  <ContainerButtonsIcon>
                    <SaveIcon />
                  </ContainerButtonsIcon>
                  <CustomButtonLabel>
                    {isLoading ? <CircularProgress size={20} /> : "Salvar"}
                  </CustomButtonLabel>
                </ButtonSave>
              </ButtonOptions>
            </ContainerButtons>
            <input
              className="x-display"
              type="submit"
              onClick={formik.handleSubmit}
            />
          </form>
          <ContainerLogo>
            <SeidorLogo src="/image/logo-default.png" />
          </ContainerLogo>
        </LoginContent>
      </RightPanel>
    </LoginContainer>
  );
}

export default NewPassword;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 8px 0;
  font-family: 'Mulish', sans-serif;
`;

const SubText = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin-bottom: 32px;
  font-family: 'Mulish', sans-serif;
`;

const FieldContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  flex: 1;
`;

const ContainerButtons = styled.div`
  display: flex;
  margin-top: 32px;
  margin-bottom: 20px;
`;

const ButtonOptions = styled.div`
  display: flex;
  flex: 1;
  gap: 12px;
`;

const ButtonCancel = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  color: #2c3e50;
  border: 1px solid #2c3e50;
  height: 48px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Mulish', sans-serif;

  &:hover {
    background-color: #f5f5f5;
  }
`;

const ButtonSave = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  background: ${(props) => (props.disable ? "#ddd" : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)")};
  border-radius: 8px;
  display: flex;
  color: white;
  height: 48px;
  cursor: ${(props) => (props.disable ? "not-allowed" : "pointer")};
  transition: all 0.3s ease;
  font-family: 'Mulish', sans-serif;
  box-shadow: ${(props) => (props.disable ? "none" : "0 4px 15px rgba(102, 126, 234, 0.4)")};

  &:hover {
    ${(props) => !props.disable && `
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
    `}
  }
`;

const CustomButtonLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const ContainerButtonsIcon = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
`;
